var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { SalesRepDataActionType } from "../../reduxStore/actions/actionTypes";
import { useDispatch } from "react-redux";
import { REDIRECT_TAB_FLAG } from "../Constant";
import { useTranslation } from "react-i18next";
import { dataAddingOnCart } from "../../reduxStore/actions/salesRepDataAction";
var AlertDialog = function (props) {
    var dispatch = useDispatch();
    var t = useTranslation().t; //* Translation *
    var handleUpdateReduxState = function (payloadData, actionType) {
        var updateReduxState = {
            payload: payloadData,
            type: actionType,
        };
        dispatch(updateReduxState);
    };
    var handleStayOnPage = function () {
        props === null || props === void 0 ? void 0 : props.setOpenAlertBox(false);
    };
    var handleLeaveonPage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(dataAddingOnCart({}, "clear.js"))];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("Error clearing cart on leaving Create Order:", error_1);
                    return [3 /*break*/, 3];
                case 3:
                    handleUpdateReduxState({}, SalesRepDataActionType.CREATE_ORDER_TAB);
                    handleUpdateReduxState({ activeTabIndex: props === null || props === void 0 ? void 0 : props.redirectTabIndex, actionEvent: REDIRECT_TAB_FLAG }, SalesRepDataActionType.ACTIVE_TAB); //redirect
                    props === null || props === void 0 ? void 0 : props.setOpenAlertBox(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(React.Fragment, { children: _jsxs(Dialog, __assign({ open: props === null || props === void 0 ? void 0 : props.openAlertBox, onClose: handleStayOnPage, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" }, { children: [_jsx(DialogTitle, __assign({ id: "alert-dialog-title" }, { children: t("alertBoxTitle") })), _jsx(DialogContent, { children: _jsx(DialogContentText, __assign({ id: "alert-dialog-description", className: "ST_CommonTextFont_size" }, { children: t("alertMessage") })) }), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ onClick: handleStayOnPage }, { children: t("stayOnPageBtn") })), _jsx(Button, __assign({ onClick: handleLeaveonPage }, { children: t("leaveOnPageBtn") }))] })] })) }));
};
export default AlertDialog;
